import { action, makeObservable, observable, transaction } from 'mobx';

import { webServiceProvider } from 'shared';

import AppStore from 'stores/App';
import ShopStore from 'stores/ShopStore';

class LocationServiceC {
  locationReports = [];
  loadedLocation = false;

  fetchLocationForShop = async (
    shopId = ShopStore.currentShop.id,
    params = {}
  ) => {
    this.loadedLocation = false;
    try {
      const { data } = await webServiceProvider.getMany(
        `v1/shops/${shopId}/cars/location`,
        params
      );
      transaction(() => {
        this.loadedLocation = true;
        this.locationReports = data;
      });
    } catch (e) {
      AppStore.addError('Error in fetching location data!');
    }
  };

  reset = () => {
    transaction(() => {
      this.locationReports = [];
      this.loadedLocation = false;
    });
  };
  constructor() {
    makeObservable(this, {
      loadedLocation: observable,
      locationReports: observable,
      fetchLocationForShop: action,
      reset: action,
    });
  }
}

export const LocationService = new LocationServiceC();
